//#region imports
import { DOCUMENT, Location } from '@angular/common';
import { ChangeDetectorRef, Component, ElementRef, HostListener, Inject, OnDestroy, ViewChild } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { DisposableSafelly } from '@toro/common/shared/components/disposable-safelly/disposable-safelly.component';
import { TrendsFilterEnum } from '@toro/common/shared/enum/quote/trends-filter.enum';
import { SuitabilityProfilesEnum } from '@toro/common/shared/enum/suitability/suitability-profiles.enum';
import { ActionEventsEnum } from '@toro/common/shared/enum/tracking/action-events.enum';
import { AppState } from '@toro/common/shared/interfaces/app-state.interface';
import { IReRegistrationMessage } from '@toro/common/shared/interfaces/re-registration/re-resgistration.interface';
import { InstrumentLite } from '@toro/common/shared/models/quote/instrument-lite.model';
import { Instrument } from '@toro/common/shared/models/quote/instrument.model';
import { Roles } from '@toro/common/shared/models/roles/roles.enum';
import { DialogsService } from '@toro/common/shared/services/dialogs.service';
import { UserReRegistationService } from '@toro/common/shared/services/re-registration/user-re-registration.service';
import { StockResearchAdvicesAction } from '@toro/common/shared/state-management/stock-research-advices/stock-research-advices.action';
import { StocksExchangeWalletEffects } from '@toro/common/shared/state-management/stocks-exchange-wallet/stocks-exchange-wallet.effects';
import { StocksMarketAction } from '@toro/common/shared/state-management/stocks-market/stocks-market.action';
import { SuitabilityAction } from '@toro/common/shared/state-management/suitability/suitability.action';
import { SuitabilityEffects } from '@toro/common/shared/state-management/suitability/suitability.effects';
import { UsersAction } from '@toro/common/shared/state-management/users/users.actions';
import { UsersEffects } from '@toro/common/shared/state-management/users/users.effects';
import { merge } from 'rxjs';
import { distinctUntilChanged, filter, first, map, take } from 'rxjs/operators';
import { HubSearchComponent } from '../../../components/hub-search/hub-search.component';
import { TrackingsService } from '../../../services/tracking.service';
import { AnalysisPreviewDialogComponent } from '../../../shared/panels/analysis-preview-dialog/analysis-preview-dialog.component';
import { StocksExploreMarketAction } from '../../../state-management/stock-explore-market/stock-explore-market.action';
import { StocksExploreMarketEffects } from '../../../state-management/stock-explore-market/stock-explore-market.effects';
import { StockResearchTrendAction } from '../../../state-management/stock-research-trend/stock-research-trend.action';

enum FilterEnum {
    mostTraded = 'mais-negociados',
    canUp = 'pode-subir',
    canDown = 'pode-cair',
    isUp = 'em-alta',
    isLow = 'em-baixa',
}

@Component({
    selector: 'home-market-explorer',
    templateUrl: './market-explorer.component.html',
    styleUrls: ['./market-explorer.component.scss']
})
export class MarketExplorerComponent extends DisposableSafelly implements OnDestroy {

    @ViewChild('stickyContent', { static: false }) public sticky: ElementRef;
    @ViewChild('stocksList', { static: false }) public stocksList: ElementRef;
    @ViewChild('exploreMarket', { static: false }) public exploreMarket: ElementRef;
    @ViewChild('hubSearch', { static: false }) public hubSearch: HubSearchComponent;

    public chips = {
        selected: 0,
        items: [
            { id: 0, value: FilterEnum.mostTraded, label: 'Mais Negociados' },
            { id: 1, value: FilterEnum.isUp, label: 'Em Alta' },
            { id: 2, value: FilterEnum.isLow, label: 'Em Baixa' },
            { id: 3, value: FilterEnum.canUp, label: 'Pode Subir' },
            { id: 4, value: FilterEnum.canDown, label: 'Pode Cair' },
        ],
    };
    public hideDetails = {};
    public offsetSticky: any;
    public hiddenCards: boolean = true;
    public onlyHiddenCards: boolean = true;
    public isMobile: boolean = false;
    public element: any;
    public ibovespaVariation: number = 0;
    public ibovespaValue: number = 0;
    public marketSearchResult: any[] = [];
    public sliderMainID: string = '#header-stock-carousel';
    public isConservativeProfile: boolean;
    public isLogged: boolean = false;
    public currentUser: any;
    public searchResultValue: any = null;
    public auxiliarCardReload: boolean = false;
    public slickCurrentSlide = 0;
    public exploreMarketList: InstrumentLite[] = [];
    public exploreMarketListMobile: InstrumentLite[] = [];
    public loading: boolean = true;
    public isAnonymous: boolean = true;
    public symbols: string[] = [];
    public userIsExpired: boolean;
    public userExpired: IReRegistrationMessage;
    public featuredAnalysis: any;
    public isLiveAttached: boolean = false;

    // TODO: implementação temporaria - tombamento clientes Pi
    // remover integrationToroPi quando todos os clientes tiverem com agreement e suitability ok --- fernando.souza
    public integrationToroPi = {
        isAgreement: true,
        isSuitability: true,
    };

    private filterValue: any = 0;
    private searchValue: any = false;
    private pristineFilter: boolean = true;

    constructor(
        public changesDetector: ChangeDetectorRef,
        public authEffects: UsersEffects,
        public stocksWalletEffects: StocksExchangeWalletEffects,
        public suitabilityEffects: SuitabilityEffects,
        private store: Store<AppState>,
        private stocksExploreEffects: StocksExploreMarketEffects,
        private activatedRoute: ActivatedRoute,
        private router: Router,
        private location: Location,
        private elementRef: ElementRef,
        private dialogsService: DialogsService,
        @Inject(DOCUMENT) private documentRef: any,
        private titleService: Title,
        private userReRegistationService: UserReRegistationService,
        private tracking: TrackingsService,
    ) {
        super();
        this.isMobile = window.document.body.offsetWidth < 1024;

        // Verifica se o usuário está logado e recupera o role.
        this.disposableSubscriptions.push(
            this.store.select((state) => state.authentication.currentUser)
                .pipe(first((user) => user))
                .subscribe((user) => {
                    this.isLogged = true;
                    this.currentUser = user;

                    // Variável utilizada para esconder o texto de % de acerto: somente usuário anônimo visualiza.
                    if ((this.currentUser.role !== Roles.Anonymous) && (this.currentUser.role !== Roles.Undefined)) {
                        this.isAnonymous = false;
                    }
                }),
        );

        // Obtem o perfil de investirdo do usuário.
        this.disposableSubscriptions.push(
            this.store.select((state) => state.suitability.profile)
                .pipe(filter((result) => result && result.profile ? true : false))
                .subscribe((data) => {
                    this.isConservativeProfile = data.profile === SuitabilityProfilesEnum.Conservative;
                }),
        );

        // Obtém a cotação da IBOVESPA.
        const IBOV = 'IBOV';
        this.disposableSubscriptions.push(
            this.store.select((state) => state.stocksExchange.stocksMarket.quote)
                .pipe(
                    filter((item) => item[IBOV]),
                    map((item) => item[IBOV])
                )
                .subscribe((data) => {
                    if(data){
                        let valueIbov = this.ibovespaValue;
                        this.ibovespaValue = data.PriceLastTrade ? data.PriceLastTrade : data.ClosingPricePreviousDay;
                        if(!this.ibovespaValue){
                            this.ibovespaValue = valueIbov ? valueIbov : 0;
                        }
                        
                        let valueVariation = this.ibovespaVariation;
                        this.ibovespaVariation = data.Variation;
                        if(!this.ibovespaVariation){
                            this.ibovespaVariation = valueVariation ? valueVariation : 0;
                        }
                    } else {
                        this.ibovespaValue = this.ibovespaValue ? this.ibovespaValue : 0;
                        this.ibovespaVariation = this.ibovespaVariation ? this.ibovespaVariation : 0;
                    }
                }),
        );

        this.disposableSubscriptions.push(
            this.store
                .select((globalStore: any) => globalStore.globals.liveIsAttached)
                .subscribe((isAttached) => {
                    this.isLiveAttached = isAttached;
                }),
        );

        // Busca os mais negociados quando vem no queryParam.
        if (!this.activatedRoute.snapshot.queryParams.filtro) {
            this.filterValue = FilterEnum.mostTraded;
            this.store.dispatch({ type: StocksExploreMarketAction.getTrends, payload: TrendsFilterEnum.MAIS_NEGOCIADAS });
        }

        if (this.activatedRoute.snapshot.queryParams.ativo) {
            this.isMobile
                ? this.showAnalysisPreview(this.activatedRoute.snapshot.queryParams.ativo)
                : this.router.navigate([`/analise/${this.activatedRoute.snapshot.queryParams.ativo}`]);
        }

        // Requisita informações
        this.store.dispatch({ type: SuitabilityAction.getProfile });
        this.store.dispatch({ type: StocksMarketAction.getQuote, payload: 'IBOV' });

        this.tracking.sendMetricsToMixpanel(ActionEventsEnum.PAGE_LOADED, {
            'Product Area Origin': 'Bolsa',
            'Step': 'Explore o mercado',
            'Time Responsável': 'Roebling',
        });
    }

    @HostListener('window:scroll', ['$event'])
    public onScroll(event) {
        const scroll = $(window)
            .scrollTop();

        const sticky = this.sticky.nativeElement.offsetTop;
        const listBottom = (
            this.stocksList.nativeElement.offsetTop
            + this.stocksList.nativeElement.offsetHeight) - this.sticky.nativeElement.offsetHeight;

        if (scroll >= sticky) {
            $('.stock-sticky')
                .addClass('sticky');
        } else {
            $('.stock-sticky')
                .removeClass('sticky');
        }
    }

    public ngOnInit() {
        this.hiddenCards = true;
        this.bindSubscriptions();
        this.onLoginStatusChanged();
    }

    public bindSubscriptions() {
        this.bindLoginEventsSubscription();
    }

    public bindLoginEventsSubscription() {
        this.disposableSubscriptions.push(
            merge(
                this.authEffects.loginSuccess$
                    .filter((loginEventFilter) => loginEventFilter.type.equals(UsersAction.loginSuccess)),
                this.authEffects.resetCurrentUser$,
            )
                .subscribe((data) => {
                    this.store.dispatch({ type: StockResearchAdvicesAction.cleanAdvices });
                }),
        );
    }

    public ngAfterViewInit() {
        this.goToSearchIfHasFilter();
        this.filterSubscriptions();
        this.offsetSticky = this.sticky.nativeElement.offsetTop + this.sticky.nativeElement.offsetHeight - 354;
        this.getUserRegistrationStore();
    }

    /**
     * Vai pra área de explore o mercado caso haja parametros de pesquisa na URL
     */
    public goToSearchIfHasFilter() {
        if (this.activatedRoute.snapshot.queryParams.acao || this.activatedRoute.snapshot.queryParams.filtro) {
            const marketList: HTMLElement = document.querySelector('#stocksList');
            $('html, body')
                .animate({ scrollTop: marketList.offsetTop - (this.isMobile ? 170 : 150) }, 800);
        }
    }

    /**
     * Ouve os eventos da barra de filtro
     * @param $event Valor recebido.
     */
    public getHubSearchEmit($event) {
        switch ($event.type) {
            case 'filter':
                if (!$event.first) {
                    $('html, body')
                        .animate({
                            scrollTop: $('#stocksList')
                                .offset().top - (this.isMobile ? 99 : 75)
                        }, 800);
                }
                switch ($event.value) {
                    case FilterEnum.mostTraded:
                    case 0:
                        this.filterValue = FilterEnum.mostTraded;
                        this.loading = true;
                        if (!this.pristineFilter) {
                            this.changeURL();
                            this.titleService.setTitle('Ativos mais Negociados - Bolsa de Valores | Toro Investimentos');
                        }
                        this.store.dispatch({ type: StocksExploreMarketAction.getTrends, payload: TrendsFilterEnum.MAIS_NEGOCIADAS });
                        break;
                    case FilterEnum.isUp:
                    case 1:
                        this.pristineFilter = false;
                        this.loading = true;
                        this.store.dispatch({ type: StocksExploreMarketAction.getTrends, payload: TrendsFilterEnum.EM_ALTA });
                        this.filterValue = FilterEnum.isUp;
                        this.changeURL();
                        this.titleService.setTitle('Ativos em Alta - Bolsa de Valores | Toro Investimentos');
                        break;
                    case FilterEnum.isLow:
                    case 2:
                        this.pristineFilter = false;
                        this.loading = true;
                        this.store.dispatch({ type: StocksExploreMarketAction.getTrends, payload: TrendsFilterEnum.EM_BAIXA });
                        this.filterValue = FilterEnum.isLow;
                        this.changeURL();
                        this.titleService.setTitle('Ativos em Baixa - Bolsa de Valores | Toro Investimentos');
                        break;
                    case FilterEnum.canDown:
                    case 3:
                        this.pristineFilter = false;
                        this.loading = true;
                        this.store.dispatch({ type: StocksExploreMarketAction.getTrends, payload: TrendsFilterEnum.PODE_CAIR });
                        this.filterValue = FilterEnum.canDown;
                        this.changeURL();
                        this.titleService.setTitle('Ativos que podem Cair - Bolsa de Valores | Toro Investimentos');
                        break;
                    case FilterEnum.canUp:
                    case 4:
                        this.pristineFilter = false;
                        this.loading = true;
                        this.store.dispatch({ type: StocksExploreMarketAction.getTrends, payload: TrendsFilterEnum.PODE_SUBIR });
                        this.filterValue = FilterEnum.canUp;
                        this.changeURL();
                        this.titleService.setTitle('Ativos que podem Subir - Bolsa de Valores | Toro Investimentos');
                        break;
                }
                break;
            case 'search':
                let searchObj: any;
                if ($event.isCached) {
                    searchObj = $event.value;
                    searchObj.isCached = true;
                }
                if (!$event.first) this.applySearch($event.isCached ? searchObj : $event.value);
                if ($event.first) this.applySearchOnLoad($event.isCached ? searchObj : $event.value);
                break;
            case 'close':
                this.searchResultValue = null;
                this.searchValue = false;
                this.disabledSearch();
                break;
        }
    }

    public loadMoreMarket() {
        let nextShow = this.exploreMarketListMobile.length;
        this.exploreMarketListMobile = this.exploreMarketList.slice(0, ++nextShow);
    }

    /**
     * Scrollar pagina para explore o mercado
     */
    public goToExploreMarket() {
        if (this.exploreMarket) {
            $('html, body')
                .animate({ scrollTop: this.exploreMarket.nativeElement.offsetTop - 50 }, 800);
        }
    }

    public showAnalysisPreview(stock: string) {
        this.store.dispatch({ type: StocksMarketAction.getInstrumentInfo, payload: stock });
        this.store.dispatch({ type: StocksMarketAction.getTrends, payload: stock });
        this.store.dispatch({ type: StockResearchTrendAction.getCompanyTrend, payload: { symbol: stock } });
        this.store.dispatch({ type: StockResearchTrendAction.getTrend, payload: { symbol: stock, time: 'Months' } });
        this.router.navigate([], { queryParams: { ativo: stock } });
        this.dialogsService.showComponentAsAsidePanel(AnalysisPreviewDialogComponent, true);
        // this.dialogsService.showComponentAsAsidePanel(AnalysisPreviewDialogComponent, false);
    }

    public redirectExternal(url: string) {
        window.location.href = `${url}`;
    }

    // TODO: implementação temporaria - tombamento clientes Pi
    // remover integrationToroPi quando todos os clientes tiverem com agreement e suitability ok --- fernando.souza
    public statusIntegrationToroPi(event: any) {
        this.integrationToroPi.isAgreement = event.isAgreement;
        this.integrationToroPi.isSuitability = event.isSuitability;
    }

    // não remover, necessário para o funcionamento correto do @AutoUnsubscribe
    public ngOnDestroy() {
        this.disposableSubscriptions.forEach((subscription) => {
            if (subscription) subscription.unsubscribe();
        });
        this.store.dispatch({ type: StocksMarketAction.unsubscribeQuotes, payload: ['IBOV'] });
        this.store.dispatch({ type: StocksMarketAction.unsubscribeQuotes, payload: this.symbols });
    }

    /**
     * Metodo pra não acumular todos os subscriptions de filtro no ngOnInit
     */
    private filterSubscriptions() {
        /** Subscricao dos ativos mais negociados */
        this.disposableSubscriptions.push(
            this.store.select((store) => store.exploreMarket.trend)
                .pipe(distinctUntilChanged())
                .subscribe((trendData) => {
                    let auxiliarList: InstrumentLite[] = [];

                    switch (this.filterValue) {
                        case FilterEnum.mostTraded:
                            auxiliarList = trendData.mostTraded;
                            break;
                        case FilterEnum.isUp:
                            auxiliarList = trendData.isUp;
                            break;
                        case FilterEnum.isLow:
                            auxiliarList = trendData.isLow;
                            break;
                        case FilterEnum.canUp:
                            auxiliarList = trendData.canUp;
                            break;
                        case FilterEnum.canDown:
                            auxiliarList = trendData.canDown;
                            break;
                    }

                    this.symbols = auxiliarList.map((item) => item.active);

                    this.store.dispatch({ type: StocksMarketAction.getTrends, payload: this.symbols });
                    this.store.dispatch({ type: StocksMarketAction.getQuote, payload: this.symbols });
                    this.exploreMarketList = auxiliarList;
                    this.exploreMarketListMobile = auxiliarList.slice(0, 5);
                    this.changesDetector.detectChanges();
                    setTimeout(() => this.loading = false);
                }),
        );

        this.disposableSubscriptions.push(
            this.store.select((store: any) => store.featuredAnalysis.filteredFeaturedAnalysis)
                .subscribe((analysis) => {
                    if (analysis.length > 0) { this.featuredAnalysis = analysis; }
                }),
        );

        /** Subscricao de erro do filtro dos ativoss */
        this.disposableSubscriptions.push(
            this.stocksExploreEffects.getTrends$
                .pipe(filter((action) => action.type.equals(StocksExploreMarketAction.getTrendsError)))
                .subscribe((data) => {
                    setTimeout(() => this.loading = false);
                }),
        );

    }

    /**
     * Aplica as alterações para a página de pesquisa
     * @param $event Valor recebido;
     */
    private applySearch($event) {
        if ($event !== '') {
            this.pristineFilter = false;
            this.searchResultValue = $event;
            this.changeURL();
            this.auxiliarCardReload = true;
            setTimeout(() => {
                this.auxiliarCardReload = false;
            }, 100);
        }
    }

    private applySearchOnLoad(value, isCached?: boolean) {
        this.store.dispatch({ type: StocksMarketAction.getInstrumentInfo, payload: value });
        this.disposableSubscriptions.push(
            this.store.select((store) => store.stocksExchange.stocksMarket.instruments)
                .pipe(
                    first((result) => result && result[value] ? true : false),
                    map((result) => result[value])
                )
                .subscribe((result) => {
                    const searchValue = new Instrument(result);
                    this.applySearch(searchValue.toInstrumentLite());
                }),
        );
    }

    /**
     * Remove alterações da url
     */
    private disabledSearch() {
        this.location.replaceState(`/explore-o-mercado`);
    }

    /**
     * Muda a URL quando aplica algum filtro
     */
    private changeURL() {
        let base = '';
        if (this.searchResultValue) base += `acao=${this.searchResultValue.isCached ? this.searchResultValue.code : this.searchResultValue.active}`;
        if (this.searchResultValue && this.filterValue) base += '&';
        if (this.filterValue) base += `filtro=${this.filterValue}`;
        this.location.replaceState(`/explore-o-mercado?${base}`);
    }

    /**
     * Aplica o estilo de ativo nos cards no carrousel
     */
    private applyCardsStatus() {
        $('.slick-list .stock-card-element:visible')
            .each(function () {
                if (($(this) as any).isVisible()) {
                    $(this)
                        .addClass('active');
                } else {
                    $(this)
                        .removeClass('active');
                }
            });
    }

    private onLoginStatusChanged() {
        this.disposableSubscriptions.push(
            merge(
                this.authEffects.forceAuthenticationRequest$
                    .pipe(filter((action) => action.type.equals(UsersAction.forcedAuthenticationSuccefully))),
                this.authEffects.logout$,
            )
                .subscribe((action) => {
                    this.store.dispatch({ type: StocksExploreMarketAction.getTrends, payload: TrendsFilterEnum.MAIS_NEGOCIADAS });
                }),
        );
    }

    /**
     * Método para verificar se o ativo buscado já existe na lista de ativos do explore o mercado
     * para não realizar nem subscrição e desinscrição de cotação desnecessária.
     */
    private checkIfQuoteIsNeeded(): boolean {
        return !this.symbols.includes(this.searchResultValue.code || this.searchResultValue.active);
    }

    /**
     * Busca os registros status do usuário
     */
    private getUserRegistrationStore() {
        this.store.select(({ userProfile }) => (userProfile))
            .pipe(take(2))
            .subscribe((up) => {
                if (!up.user || !+up.user.registrationStatus) { return; }
                this.verifyUserReRegister(+up.user.registrationStatus);
            });
    }

    /**
     * verifica se usuário está expirado
     * Expired = 15
     */
    private verifyUserReRegister(registrationStatus: number) {
        const userExpired = this.userReRegistationService.validateUserExpired(registrationStatus);
        if (!!userExpired) {
            this.userIsExpired = !!userExpired;
            this.userExpired = userExpired;
            return;
        }
    }
}
